import fukoText from 'constants/platformText/fukoText';
import { IPlatformData } from 'interfaces/config/appConfig';
import FukoWebAppPages from 'routes/manageRoute/platformRoutes/fukoWebApp';
import requestToServer from './requestToServer';

export const Platform = {
  FukoWebApp: 'FukoWebApp',
};

export const CURRENT_PLATFORM = process.env.REACT_APP_PLATFORM || '';

const platformData: IPlatformData = {
  [Platform.FukoWebApp]: {
    pages: FukoWebAppPages,
    text: fukoText,
    requestOption: requestToServer.FUKOWebApp,
  },

  // Add configurations for other platforms (MtoU, etc.) here if needed
};

export const AppConfig = (
  platform: string = CURRENT_PLATFORM
): IPlatformData => {
  return platformData[platform] || platformData[Platform.FukoWebApp];
};
